import { useState } from "react";
import {
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  useSimpleFormIteratorItem,
  ReferenceInput,
  TextInput,
} from "react-admin";
import dataProvider from "server/dataProvider";
import { Grid, Typography } from "@mui/material";
import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { settings } from "app";
import { TaxTypes } from "utils/constants";
import { administrationRequests } from "api/administrationApi";
import { useNotifyError } from "utils/useNotifyError";

const RemovePreferenceRow = ({ formData, setDiscount, setDocTypesByIndex }) => {
  const { index, remove } = useSimpleFormIteratorItem();
  const preferenceId = formData?.preferences ? formData?.preferences[index].id : "";

  const handleRemove = () => {
    remove();
    setDocTypesByIndex(prev => {
      const newState = { ...prev };
      delete newState[index]; // Remove that row’s state
      return newState;
    });
    setDiscount(prev => {
      if (!Array.isArray(prev)) return prev || [];
      return prev.filter(item => item?.id !== preferenceId);
    });
  };

  return (
    <Button
      color="error"
      onClick={handleRemove}
      startIcon={<DeleteIcon />}
    ></Button>
  );
};
const PreferenceRowFiles = ({ setDiscount, docTypesByIndex, setDocTypesByIndex, formData, isDisable = false }) => {
  const { index } = useSimpleFormIteratorItem();
  const preferenceId = formData?.preferences ? formData?.preferences[index].id : "";
  const [rowPid, setRowPid] = useState(null);
  const notifyError = useNotifyError();

  const handlePreferenceChange = async id => {
    try {
      if (!id) return;
      const prefRes = await dataProvider.customRequest(administrationRequests.getPreferenceById(id));

      const preference = prefRes.data;
      const rawDocTypes = prefRes.data.documentTypes || [];
      const discounts = prefRes.data.discounts;

      const discountMap = Object.entries(TaxTypes).reduce((acc, [key, taxTypeId]) => {
        acc[key] = discounts.some(x => x?.taxTypeId === taxTypeId && x?.percentage === 100);
        return acc;
      }, {});

      setDiscount(prev => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated[index] = {
          id: preference.id,
          discounts: discountMap,
        };
        return updated;
      });

      setRowPid(prefRes.data.preferenceAdditionalData || []);

      const allDocTypesRes = await dataProvider.customRequest(
        administrationRequests.getPreferenceDocumentTypesSelect(),
      );
      const allDocTypes = allDocTypesRes.data;

      const filteredDocTypes = rawDocTypes
        .map((doc, idx) => {
          const existTypes = allDocTypes.find(item => item.id === doc.id);
          return existTypes ? { ...existTypes, count: doc.count } : null;
        })
        .filter(Boolean);

      setDocTypesByIndex(prev => ({
        ...prev,
        [index]: filteredDocTypes,
      }));
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <Grid
      container
      spacing={2}
    >
      {" "}
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="id"
          reference={administrationRequests.getPreferencesSelect()}
          filter={{ isZvo: true }}
        >
          <SelectInput
            label="Група"
            optionText="nameBg"
            onChange={e => handlePreferenceChange(e.target.value)}
            readOnly={isDisable}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
        sx={{ marginTop: "-2rem" }}
      >
        {docTypesByIndex?.[index] &&
          docTypesByIndex[index].map(item => (
            <Grid
              key={item?.id}
              container
            >
              <Grid
                item
                xs={12}
                md={preferenceId && rowPid?.length > 0 ? 6 : 11}
                sx={{ marginTop: "2rem" }}
              >
                <Typography
                  color="primary"
                  variant="h6"
                  sx={{ width: "100%", textAlign: "center", marginTop: "1rem" }}
                >
                  {item?.name}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
              >
                {preferenceId &&
                  rowPid?.length > 0 &&
                  rowPid?.map((pid, idx) => (
                    <TextInput
                      key={idx}
                      sx={{ marginTop: "2.5rem" }}
                      source={`additionalData.${pid.key}`}
                      label={pid.labelBg}
                    />
                  ))}
              </Grid>
              {/* <Grid
                item
                xs={12}
                md={6}
              >
                {preferenceId &&
                  [...Array(item?.count)].map((_, i) => (
                    <FileInput
                      key={i}
                      source={`files.preference${preferenceId}.docType${item?.id}.${i}`}
                      label={`Прикачи `}
                    >
                      <FileField
                        source="src"
                        title="title"
                      />
                    </FileInput>
                  ))}
              </Grid>  */}
            </Grid>
          ))}
      </Grid>
    </Grid>
  );
};

const PreferenceSection = ({ setDiscount, formData, defaultValue = [{}], isDisable = false }) => {
  const [docTypesByIndex, setDocTypesByIndex] = useState({});

  return (
    <Grid
      item
      xs={12}
    >
      <ArrayInput
        source="preferences"
        defaultValue={defaultValue}
        label="Групи по чл.68, ал.3 от ЗВО"
      >
        <SimpleFormIterator
          disableRemove
          disableReordering
          sx={settings.style.iteratorWithoutGap}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <PreferenceRowFiles
              setDiscount={setDiscount}
              docTypesByIndex={docTypesByIndex}
              setDocTypesByIndex={setDocTypesByIndex}
              formData={formData}
              isDisable={isDisable}
            />
            <RemovePreferenceRow
              formData={formData}
              setDiscount={setDiscount}
              setDocTypesByIndex={setDocTypesByIndex}
            />
          </div>
        </SimpleFormIterator>
      </ArrayInput>
    </Grid>
  );
};

export default PreferenceSection;
